module.exports = __webpack_public_path__ + "static/img/icon_94_topno.bde3b7eb.png";